import { supabase } from "@/lib/supabase";
import type { LeadTargetField } from "@/lib/leadFields";

export interface ColumnMappingRow {
  id: string;
  team_id: string;
  name: string;
  mapping: Record<string, LeadTargetField>;
  created_by: string;
  created_at: string;
  updated_at: string;
}

/** Team-wide default preset used by import mapping step. */
export async function getDefaultColumnMapping(teamId: string): Promise<Record<string, LeadTargetField> | null> {
  const { data, error } = await supabase
    .from("column_mappings")
    .select("mapping")
    .eq("team_id", teamId)
    .eq("name", "default")
    .maybeSingle();
  if (error) throw error;
  return (data?.mapping as Record<string, LeadTargetField> | undefined) ?? null;
}

/** Upserts a team-wide default preset. */
export async function saveDefaultColumnMapping(
  teamId: string,
  userId: string,
  mapping: Record<string, LeadTargetField>,
): Promise<void> {
  const { error } = await supabase
    .from("column_mappings")
    .upsert(
      {
        team_id: teamId,
        name: "default",
        mapping,
        created_by: userId,
      },
      { onConflict: "team_id,name" },
    );
  if (error) throw error;
}
